// extracted by mini-css-extract-plugin
module.exports =  {"container":"container_gPhDSePr","title":"title_Ty4ditrt","info":"info_UsXECujx"};